import perfilService from 'lg-vue-components/services/perfilService';
import portalService from 'lg-vue-components/services/portalService';

const actions = {
  carregueProdutos({ commit }) {
    perfilService.getProdutos().then((res) => {
      commit('setDadosProdutos', res);
    });
  },
  carreguePerfil({ commit }, opcoes) {
    perfilService.getPerfil(opcoes.carregueMenu, opcoes.carregueMenuSair).then((res) => {
      commit('setDadosUsuarioLogado', res);
    });
  },
  carregueLogotipo({ commit }) {
    portalService.getLogotipo().then((res) => {
      commit('setLogotipo', res);
    });
  },
};

export default actions;
